import React from "react";

const Pagination = ({
  paginationInfo,
  handleNextPage,
  handlePreviousPage,
  onPageChange,
  onPageSizeChange,
}) => {
  const { pageNumber, pageSize, totalPages, totalElements } = paginationInfo;

  const pageSizes = [10, 25, 50, 75, 100];
  const safeTotalPages = Math.max(1, Number(totalPages) || 1);
  const safePageNumber = Math.min(Math.max(Number(pageNumber) || 0, 0), safeTotalPages - 1);
  const hasEntries = Number(totalElements) > 0;
  const startIndex = hasEntries ? safePageNumber * pageSize + 1 : 0;
  const endIndex = hasEntries ? Math.min(startIndex + pageSize - 1, totalElements) : 0;

  const BRAND_BLUE = "#0147C8";

  const generatePageNumbers = () => {
    const pages = [];
    const addPage = (value) => {
      if (pages[pages.length - 1] !== value) pages.push(value);
    };

    if (safeTotalPages <= 5) {
      for (let i = 0; i < safeTotalPages; i += 1) addPage(i);
    } else {
      if (safePageNumber <= 2) {
        addPage(0);
        addPage(1);
        addPage(2);
        addPage("...");
        addPage(safeTotalPages - 1);
      } else if (safePageNumber >= safeTotalPages - 3) {
        addPage(0);
        addPage("...");
        addPage(safeTotalPages - 3);
        addPage(safeTotalPages - 2);
        addPage(safeTotalPages - 1);
      } else {
        addPage(0);
        addPage("...");
        addPage(safePageNumber - 1);
        addPage(safePageNumber);
        addPage(safePageNumber + 1);
        addPage("...");
        addPage(safeTotalPages - 1);
      }
    }

    return pages;
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <div className="mb-2">
        <span>
          Showing {startIndex} to {endIndex} of {totalElements} entries
        </span>
      </div>

      <div className="d-flex align-items-center mb-2">
        <div className="mb-2">
          <span>Rows per page:</span>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;

        <div className="mb-2">
          <select
            className="form-select form-select-sm"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;

        <ul className="pagination pagination-sm mb-2">
          <li className={`page-item ${safePageNumber === 0 ? "disabled" : ""}`}>
            <button
              type="button"
              className="page-link"
              aria-label="Previous"
              disabled={safePageNumber === 0}
              onClick={handlePreviousPage}
            >
              &lt;
            </button>
          </li>

          {/* Page Numbers */}
          {generatePageNumbers().map((page, index) => (
            <li
              key={index}
              className={`page-item ${
                page === "..." ? "disabled" : page === safePageNumber ? "active" : ""
              }`}
            >
              <button
                type="button"
                style={page === safePageNumber ? { backgroundColor: BRAND_BLUE, borderColor: BRAND_BLUE } : undefined}
                className="page-link"
                onClick={() => typeof page === "number" && onPageChange(page, pageSize)}
                disabled={page === "..."}
              >
                {page === "..." ? "..." : page + 1}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${
              safePageNumber >= safeTotalPages - 1 ? "disabled" : ""
            }`}
          >
            <button
              type="button"
              className="page-link"
              aria-label="Next"
              disabled={safePageNumber >= safeTotalPages - 1}
              onClick={handleNextPage}
            >
              &gt;
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pagination;
